import { Box, Flex, Heading, Image, Text, useBreakpoint } from "@highoutput/ui-components";
import For from "../utilities/for";

const mock = [
  `Meet Jyn, a Product Manager who struggled with understanding and valuing her emotions and battling procrastination. She decided to take advantage of Advante's coaching service that is offered by her company. But with the help of Advante's coaching, she was able to develop healthy habits and practice self-care, leading to increased productivity and success in her career journey.`,
  `Through the coaching sessions, Jyn received guidance and support as she worked towards her goals. The personalized report of her coaching assessments and action plans provided her with a clear roadmap for success. With the help of Advante's coaching, Jyn was able to make significant progress in her career and achieve her goals.`,
  `If you're looking to close the gap between where you are and where you'd like to be in your career journey, join Advante's 2-day free coaching campaign. Our experienced coaches will help you discover your goal outcomes, create a plan of action, and provide guidance and support throughout the process. You'll also receive a personalized report of your coaching assessments and action plans three days after your sessions. Start your transformational journey like Jyn did and experience the benefits of coaching with Advante.`,
];

const CaseStudyContent = () => {
  const breakpoint = useBreakpoint();
  const shouldReverse = !["base", "xs", "sm", "md"].includes(breakpoint);
  return (
    <Box>
      <Flex
        bgColor="white"
        direction={{ base: "column", lg: "row" }}
        justifyContent={{ lg: "flex-start", "2xl": "center" }}
        alignItems={{ base: "center", lg: "flex-end" }}
        marginLeft="auto"
        gap={{ base: 0, lg: 10, xl: 20 }}
      >
        <Box
          px={{ base: "4.25rem", lg: "69.5px", xl: "160px" }}
          py={{ base: "2rem", lg: "3rem", xl: "80px" }}
          bgColor="rgba(240,237,236,0.2)"
          order={!shouldReverse ? 1 : 0}
        >
          <Image
            src="images/campaign/jyn-image.webp"
            alt="jyn"
            loading="lazy"
            objectFit="cover"
            w={{ base: 240, lg: 405, xl: 400 }}
            h={{ base: 296, lg: 580, xl: 560 }}
          />
        </Box>
        <Box
          w={{ base: "auto", lg: 480 }}
          mt={{ base: "3.5rem", lg: 0 }}
          mb={{ base: "2rem", lg: "5rem" }}
          bgColor="white"
          mx="1rem"
        >
          <Text color="rgba(13,48,80,0.8)" fontWeight={500} variant="20/20" mb="1rem">
            Case Study
          </Text>
          <Heading variant={{ base: "32/36", lg: "40/44", xl: "56/64" }} fontWeight={400}>
            From Struggling to Thriving: How Advante Coaching Helped Jyn Achieve Success
          </Heading>
        </Box>
      </Flex>
      <Flex
        direction="column"
        bgColor="white"
        m={{ base: "auto", lg: "24px", xl: "auto" }}
        w={{ base: 343, lg: 980, xl: 1120 }}
        mt={{ base: 0, lg: "3rem", xl: "4rem" }}
        mb={{ base: "4rem", lg: "5rem", xl: "128px" }}
      >
        <Box>
          <For each={mock}>
            {(content, index) => (
              <Text
                color="rgba(13,48,80,0.8)"
                variant={{ base: "18/28", lg: "24/36", xl: "24/36" }}
                mt={{ base: "2rem", lg: 0 }}
                mb="1rem"
                key={index}
              >
                {content}
              </Text>
            )}
          </For>
        </Box>
      </Flex>
    </Box>
  );
};

export default CaseStudyContent;
